var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NotificationList',{staticClass:"p-2 b-a-2 bg-white",attrs:{"notices":_vm.user.attributes || [],"user":_vm.user},on:{"change":_vm.changeNotice}})
}
var staticRenderFns = []

export { render, staticRenderFns }